import { getToastService } from "./ToastProvider";
import type { IToastOptions } from "./ToastProvider";

export const showToastService = async (options: IToastOptions) => {
  const service = getToastService();
  if (!service) {
    console.warn("⚠️ ToastProvider ainda não foi inicializado.");
    return;
  }
  await service.showToast(options);
};
